import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@mui/material/Typography';
import isEmpty from 'lodash/isEmpty';
import IconTooltipButton from '../../../../../button/IconTooltipButton';
import { setParentData } from '../../utils';

const ElementChildren = ({ id, child, index, onSettingElement, onSettingChildren, parent, parentChildren, elementId, elementsStructure, parentElements }) => {
  return (
    <div className={`flex border-l border-muted ${index ? 'border-t': ''}`} >
      <div className={`flex items-center pl-2 py-2 pr-10 gap-2 relative ${child.elements?.length > 0 ? 'w-1/3 min-w-200px' :' w-full min-w-250px'}`}>
        { !isEmpty(child?.icon) && 
          <span
            className='size-8 flex items-center justify-center rounded-full'
            style={{
              color: child?.secondaryColor ?? 'inherit',
              backgroundColor: child?.primaryColor ?? 'inherit'
            
            }}
          >
            <FontAwesomeIcon icon={child?.icon} className='text-md text-primary-foreground' /> 
          </span>
        }
        <Typography
          component={'span'}
          className='text-shadow-xs'
          style={{
            backgroundColor: child.secondaryColor ?? 'inherit',
            color: child.primaryColor ?? 'inherit'
          }}
        >
          {child.name}
        </Typography>
        <div className='absolute top-1 right-1'>
          <IconTooltipButton
            title='Setting'
            icon={["far", "ellipsis-vertical"]}
            className=''
            style={{
              borderRadius: '0.5rem',
              backgroundColor: 'var(--background)',
              color: 'var(--primary)',
              padding: '0.45rem 0.4rem',
              width: '1.5rem',
              height: '1.5rem'
            }}
            onClick={(e) => onSettingChildren(e, {
              children: child,
              element: {
                _id: elementId
              },
              elementIds: child.elements.map((el) => el.elementStructureId),
              parentElements,
              parent: parentChildren,
              index 
            })}
          />
        </div>
      </div>
      { child.elements?.length > 0 && (
        <div className='flex flex-col w-full h-full'>
          { child.elements.map((el, index) => {
            const elementData = elementsStructure?.children?.find((item) => String(item._id) === String(el.elementStructureId));
            return (
              <Element 
                id={`${id}-element-${el._id}-${index}`}
                key={`${id}-element-${el._id}-${index}`}
                elementData={elementData}
                element={el}
                index={index}
                onSettingElement={onSettingElement}
                onSettingChildren={onSettingChildren}
                parent={{
                  ...parent,
                  parent: {
                    _id: child._id,
                    name: child.name
                  }
                }}
                parentChildren={setParentData({ _id: child._id, name: child.name }, parentChildren)}
                parentElements={setParentData({ _id: elementData._id, name: elementData.name }, parentElements)}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}

const Element = ({ id, element, elementData = {}, index, onSettingElement, onSettingChildren, parent, parentChildren, parentElements }) => (
  <div 
    className={[
      `flex w-full h-full border-l border-muted relative`,
      index ? 'border-t ': '',
    ].join(' ')}
  >
    <div
      className='capitalize pl-2 py-2 pr-10 flex items-center relative'
      style={{
        color: elementData.secondaryColor ?? 'inherit',
        backgroundColor: elementData.primaryColor ?? 'inherit'
      }}
    >
      <Typography className='min-w-100px '>
        {elementData.name}
      </Typography>
      <div className='absolute top-1 right-1'>
        <IconTooltipButton
          title='Setting'
          icon={["far", "ellipsis-vertical"]}
          className=''
          style={{
            borderRadius: '0.5rem',
            backgroundColor: 'var(--background)',
            color: 'var(--primary)',
            padding: '0.45rem 0.4rem',
            width: '1.5rem',
            height: '1.5rem'
          }}
          onClick={(e) => onSettingElement(e, {
            element,
            parent, 
            parentElements,
            index 
          })}
        />
      </div>
    </div>
    { element.children?.length > 0 && (
      <div className='flex flex-col'>
        { element.children.map((child, jindex) => (
          <ElementChildren
            id={`${id}-element-${child._id}-${index}`}
            key={`${id}-element-${child._id}-${index}`}
            child={child}
            elementId={element._id}
            element={element}
            index={jindex}
            onSettingElement={onSettingElement}
            onSettingChildren={onSettingChildren}
            parent={parent}
            parentChildren={setParentData({ _id: elementData._id, name: elementData.name }, parentChildren)}
            elementsStructure={elementData}
            parentElements={parentElements}
          />))
        }
      </div>
    )}
  </div>
)

export default Element